import React from 'react';

export default () => (
  <div className="section-progress">
    <div className="container">
      <ul className="b-progress-list row list-unstyled">
        <li className="b-progress-list__item col-md-4">
          <div className="b-progress-list__wrap bg-light">
            <span
              className="b-progress-list__percent js-chart"
              data-percent="20"
            >
              <span className="js-percent" />
              <span>+</span>
              <br />
              <span className="b-progress-list__name">
                {startup.content.YearsOfExperience}
              </span>
            </span>
          </div>
        </li>
        <li className="b-progress-list__item col-md-4">
          <div className="b-progress-list__wrap bg-light">
            <span
              className="b-progress-list__percent js-chart"
              data-percent="5000"
            >
              <span className="js-percent" />
              <span>+</span>
              <br />
              <span className="b-progress-list__name">
                {startup.content.SatisfiedСustomers}
              </span>
            </span>
          </div>
        </li>
        <li className="b-progress-list__item col-md-4">
          <div className="b-progress-list__wrap bg-light">
            <span
              className="b-progress-list__percent js-chart"
              data-percent={startup.carsInStock}
            >
              <span className="js-percent" />
              <span>+</span>
              <br />
              <span className="b-progress-list__name">
                {startup.content.СarsForSale}
              </span>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
);
